import { Box, H2 } from '@bigcommerce/big-design';
import { ImageDropzone } from '../../../../../../components/ImageDropzone';
import './MultipleImageUpload.css';

export function MultipleImageUpload({ customer, setCustomerInformation }) {
	return (
		<Box padding="medium">
			<H2>Attach Photos</H2>
			<ImageDropzone
				photos={customer.photos || []}
				onAddPhotos={(photos) =>
					setCustomerInformation('photos', [
						...(customer.photos || []),
						...photos,
					])
				}
				onRemovePhoto={(photoToRemove) =>
					setCustomerInformation(
						'photos',
						(customer.photos || []).filter(
							(photo) => photo !== photoToRemove,
						),
					)
				}
			/>
		</Box>
	);
}
